<ng-container *hasPermission="PermissionForStudents.PRODUCT_PACKAGES">
<div class="pricing-backdrop">
  <div class="pricing-modal" *ngIf="studentPackage">
    <div class="top-icon">
      <i class="bi bi-wallet2"></i>
    </div>

    <h2 class="title text-center">{{ studentPackage.product_name }}</h2>

    <div class="price">
      <span class="amount">{{ studentPackage.price_display }}</span>
      <span class="duration"
        >/ user</span
      >
    </div>

    <p class="subtitle text-center">Everything you need to learn, prepare, and succeed.</p>

    <div class="included">
      <span class="check">✔</span>
      <span>What's Included</span>
    </div>
    <div
      class="feature"
      *ngFor="let feature of studentPackage.package_features; let i = index">
      <div class="icon">
        <i
          class="bi"
          [ngClass]="{
            'bi-journal-text': i === 0,
            'bi-clipboard-check': i === 1,
            'bi-mic': i === 2,
            'bi-person-video3': i === 3,
            'bi-graph-up': i === 4,
			'bi-ui-checks': i === 5
          }"
        ></i>
      </div>
      <div>
        <h4>{{ feature.feature_name }}</h4>
        <p> {{feature.description || 'N/A'}}</p>
      </div>
    </div>

    <button class="btn-add w-100" (click)="openReferralCodeDialogBox()"
	*hasPermission="PermissionForStudents.PAYMENTS_CREATE">Pay Now</button>
	 <button class="btn-add logout w-100" (click)="postStudentFreeActiveSubscription()">
    <i class="bi bi-rocket-fill"></i> Start Free Trial </button>
  </div>
</div>
</ng-container>